import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | NODE] Get Entity Success',
  GetRootEntitySuccess = '[STORE | ENTITY | NODE] Get Root Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | NODE] Get Entities Success',
  GetRootEntitiesSuccess = '[STORE | ENTITY | NODE] Get Root Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | NODE] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | NODE] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | NODE] Add Entity',
  UpdateEntity = '[STORE | ENTITY | NODE] Update Entity',
  RemoveEntity = '[STORE | ENTITY | NODE] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | NODE] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | NODE] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | NODE] CleanUp Snapshots',
  RearrangeNodes = '[STORE | ENTITY | NODE] Rearrange Nodes',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Root Entity Success
 */
export class GetRootEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetRootEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Get Root Entities Success
 */
export class GetRootEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetRootEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.NodeEntityModels.NodeEntityType> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.NodeEntityModels.NodeEntityType> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.NodeEntityModels.NodeEntityType> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Rearrange Nodes
 */
export class RearrangeNodes {
  public static readonly type = ActionTypes.RearrangeNodes;

  public constructor(public node: FlatModels.NodeEntityModels.NodeEntityType | null,
                     public children: FlatModels.NodeEntityModels.NodeEntityType[] | string[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>